<template>
    <form @submit.prevent="validateForm" ref="form">
        <div v-if="postSuccessful !== null" class="messages-container">
            <div v-if="! messages.length && ! postSuccessful">
                <div class="alert alert-danger">
                    Er is een onbekende fout opgetreden
                </div>
            </div>

            <div v-for="message in messages"
                 :class='{"alert": true, "alert-success": postSuccessful, "alert-warning": ! postSuccessful}'>
                {{ message }}
            </div>
        </div>

        <div class="table-container">
            <div v-if="isLoading" class="js-loading-container">
                <div class="la-ball-clip-rotate js-loading la-2x"><div></div></div>
            </div>

            <table class="table table-striped table-hover display table-discounts">
                <thead class="thead_wrapper">
                <tr>
                    <th class="p-3 th-medium">Brandstof</th>
                    <th class="p-3">Artikel<br>nummer</th>
                    <th class="p-3">Voorgaande<br>pompprijs</th>
                    <th class="p-3">Voorgaande<br>pompkorting<br>(begindatum)</th>
                    <th class="p-3">Voorgaande<br>pompkorting</th>
                    <th class="p-3">Wijziging</th>
                    <th class="p-3">Nieuwe<br>pompkorting</th>
                    <th class="p-3">Huidige<br>LAP</th>
                    <th class="p-3">Nieuwe<br>pompprijs</th>
                    <th class="p-3">Nieuwe<br>pompkorting<br>(begindatum)</th>
                    <th class="p-3 no-sort"></th>
                    <th class="p-3 no-sort"></th>
                </tr>
                </thead>

                <tbody v-if="isLoaded && ! hasReviewableRows">
                <tr>
                    <td colspan="12">
                        <em>Er zijn geen Pompkorting mutaties die door jou kunnen wijzigen</em>
                    </td>
                </tr>
                </tbody>

                <tbody v-for="(discountMutations, brandId) in discountMutationsPerStation">
                <tr class="dtrg-group start-group">
                    <td colspan="12">{{discountMutations[0].station.name}}</td>
                </tr>


                <FuelDiscountMutationsReviewalTableRow v-for="discountMutation in discountMutations"
                                                  :key="discountMutation.id"
                                                  :discountMutation="discountMutation"
                                                  ref="reviewalRow"/>
                </tbody>
            </table>

            <div v-if="hasReviewableRows" class="row">
                <div class="col"></div>
                <div class="col-auto text-center">
                    <div class="p-3 py-4">Wijzigingen bevestigen</div>

                    <div :title="submitButtonTooltip" data-toggle="tooltip">
                        <button :disabled="!allRowsReviewed"
                                class="btn btn-red m-0 w-100 text-center"
                                type="submit">
                            Bevestig
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import axios from 'axios';
    import FuelDiscountMutationsReviewalTableRow from './FuelDiscountMutationsReviewalTableRow'

    export default {
        components: {
            FuelDiscountMutationsReviewalTableRow
        },

        data() {
            return {
                isLoading: false,
                isLoaded: false,
                discountMutationsPerStation: {},
                messages: [],
                postSuccessful: null
            };
        },

        mounted() {
            this.$on('loaded', this.onLoaded)
            this.getDiscountMutations()
        },

        computed: {
            allRowsReviewed() {
                if (!this.isLoaded) {
                    return
                }

                let numberOfReviewedRows = this.$refs.reviewalRow.filter(row => {
                    return row.isReviewed
                }).length

                return numberOfReviewedRows === this.$refs.reviewalRow.length
            },

            hasReviewableRows() {
                return Object.keys(this.discountMutationsPerStation).length > 0
            },

            submitButtonTooltip() {
                return this.hasReviewableRows && !this.allRowsReviewed ?
                    'Een of meer regels zijn nog niet goedgekeurd of aangepast' : ''
            }
        },

        watch: {
            submitButtonTooltip(value) {
                this.$nextTick(function() {
                    $('[data-toggle="tooltip"]').tooltip(value ? 'enable' : 'dispose')
                })
            }
        },

        methods: {
            getDiscountMutations() {
                this.isLoading = true

                axios.get(route('admin.api.discounts.reviewable'))
                    .then((response) => this.discountMutationsPerStation = response.data)
                    .catch()
                    .then(() => this.$nextTick(() => {
                        this.isLoading = false

                        if (! this.isLoaded) {
                            this.isLoaded = true
                            this.$emit('loaded')
                        }
                    }))
            },

            onLoaded() {
                $('[data-toggle="tooltip"]').tooltip()
            },

            validateForm(e) {
                if (!this.allRowsReviewed) {
                    return;
                }

                let formData = new FormData(e.target)

                this.isLoading = true

                axios.post(route('admin.api.discounts.review'), formData)
                    .then((response) => {
                        this.discountMutationsPerStation = response.data.discount_mutations || []
                        this.messages = response.data.messages || []
                        this.postSuccessful = response.data.success || false
                    })
                    .catch((response) => {
                        this.messages = []
                        this.postSuccessful = false
                    })
                    .then(() => this.$nextTick(() => {
                        this.isLoading = false
                    }))
            }
        }
    }
</script>

<style lang="scss" scoped>
    button[type=submit]:disabled {
        pointer-events: none;
    }

    .js-loading-container {
        background: rgba(255, 255, 255, .73);
        display: block;
        height: 100%;
        padding: 50px 0;
        position: absolute;
        text-align: center;
        top: 0;
        width: 100%;
        z-index: 10;
    }

    .table-container {
        position: relative;
    }

    th {
        white-space: nowrap;
    }
</style>
